import { gql } from 'apollo-boost';

export const RESEND_ADMIN_DATA_EXPORT_EMAIL = gql`
    mutation ResendAdminDataExportEmail($id: ID!) {
        resendAdminDataExportEmail(id: $id)
    }
`;
